import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import DatosSocio from "../../generico/DatosSocio"
import { trackPromise } from "react-promise-tracker";
import Select from "react-select";
import Popup from "react-popup";
import { formatoSeparadorMilesValueExtracto } from "../../generico/utils/FormatoInput";
import MensajeUsuario from "../../generico/MensajeUsuario";
import ExtractoService from "../../../services/consultas/ExtractoService";
import TarjetaService from "../../../services/pagos/TarjetaService";
import { MENSAJE } from "../../generico/utils/Constantes";
import history from "../login/history";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

const TEXT_ERROR = "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste.";

const fechaActual = new Date();
const PERIODO_A_LA_FECHA = "aLaFecha";

export default class ExtractoPanalCabal extends Component {

  constructor(props) {
    super(props);
    this.state = {
      tipoTarjeta: "Panal",
      listaPeriodo: [
        {
          value: PERIODO_A_LA_FECHA,
          label: "Extracto a la fecha",
        }
      ],
      listaExtracto: [],
      periodoElegido: null,
      cuenta: sessionStorage.getItem("cuenta"),
      nroTarjeta: sessionStorage.getItem("resumen"),
      cabecera: {},
      detalle: [],
      datosTarjeta: {}
    };

  }

  componentDidMount() {
    this.consultarExtracto();
    this.getInfoTarjeta();
  }

  notifiPopup = (titulo, mensaje, callback) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              callback && callback();
              Popup.close();
            },
          },
        ],
      },
    });


  getInfoTarjeta = () => {

    let { datosTarjeta, nroTarjeta } = this.state;

    trackPromise(
      TarjetaService.getInfoTarjeta()
        .then(response => {
          let { data } = response.data;

          if (data.length === 0) {
            Popup.queue(this.notifiPopup("Error", MENSAJE.ERROR_INESPERADO, history.goBack));
            return null;
          }

          datosTarjeta = data.find(value => value.NUMERO_TARJETA === nroTarjeta);
          this.setState({ datosTarjeta });

        })
        .catch(error => {
          console.log(error);
          Popup.queue(this.notifiPopup("Error", MENSAJE.ERROR_INESPERADO, history.goBack))
        })
    )
  }


  consultarExtracto = () => {

    let cuenta = this.state.cuenta;

    let data = {
      "numeroCuenta": cuenta,
      "mesActual": fechaActual.getMonth() + 1,
      "anhoActual": fechaActual.getFullYear()
    }

    ExtractoService.consultaExtractoCabal(data)
      .then(response => {

        let { data, header } = response.data;
        let { listaPeriodo } = this.state;

        if (header.codReturn === "0") {

          if (data.length === 0) {
            //Popup.queue(this.notifiPopup("Info", header.txtRespuesta, history.goBack));
            return null;
          }

          data.forEach(item => {

            let { MES, ANIO } = item;

            let mesLabel = MES.length > 1 ? MES : "0" + MES;

            listaPeriodo.push({
              value: MES + ANIO,
              label: mesLabel + "/" + ANIO,
            });

          });

          this.setState({ listaPeriodo, listaExtracto: data });

        } else {
          Popup.queue(this.notifiPopup("Info", header.txtRespuesta, history.goBack));
        }

      })
      .catch(error => {
        console.log(error);
        Popup.queue(this.notifiPopup("Error", TEXT_ERROR, history.goBack));
      })
  }

  handleChangePeriodoSelector = (selectedOption) => {
    if (selectedOption === null)
      this.setState({
        periodoElegido: null, listaResumen: []
      });
    else {
      this.setState({
        periodoElegido: selectedOption.value
      })
    }
  }

  descargarExtracto = () => {

    let { cuenta, periodoElegido, listaExtracto, datosTarjeta, detalle } = this.state;

    let extracto = listaExtracto.find(extracto => {
      let mesAnio = extracto.MES + extracto.ANIO;
      if (mesAnio === periodoElegido) return extracto;
      return null;
    });

    if (periodoElegido === PERIODO_A_LA_FECHA) {

      const periodoActualTarjeta = datosTarjeta.PERIODO_ACTUAL_TARJETA;

      const anhoActual = periodoActualTarjeta.substr(0, 4);
      const mesActual = periodoActualTarjeta.substr(-2);

      let data = {
        "canal": "WEB",
        "emisor": datosTarjeta.EMISOR,
        "anhoActual": anhoActual,
        "mesActual": mesActual,
        "cierre": datosTarjeta.CIERRE,
        "numeroTarjeta": datosTarjeta.NUMERO_TARJETA,
        "numeroCuenta": datosTarjeta.NUMERO_CUENTA,
        "adicional": datosTarjeta.ADICIONAL,
        "flgAdicional": "1"
      }

      trackPromise(
        ExtractoService.consultarMovimientos(data)
          .then((response) => {

            let { data, header } = response.data;

            if (header.codReturn === "0") {

              if (data.length === 0) {
                Popup.queue(this.notifiPopup("Info", "No se encontraron movimientos para el periodo actual."));
                return null;
              }

              detalle = data.map(extracto => {
                return {
                  numeroTarjeta: datosTarjeta.NUMERO_TARJETA,
                  fechaTransaccion: extracto.FECHA_MOVIMIENTO,
                  comercio: extracto.NOMBRE_COMERCIO,
                  tipoTransaccion: extracto.CRED === "0" ? "Débito" : "Crédito",
                  importeGuaranies: extracto.IMPORTE
                }
              });

              this.setState({ detalle });

            } else {
              this.setState({ cabecera: {}, detalle: [] });
              Popup.queue(this.notifiPopup("Info", header.txtReturn));
              return;
            }
          })
          .catch(error => {
            console.log(error);
            Popup.queue(this.notifiPopup("Error", TEXT_ERROR));
          })
      );

    } else {

      let data = {
        canal: "WEB",
        numeroCuenta: cuenta,
        anio: extracto.ANIO,
        mes: extracto.MES,
        emisor: extracto.EMISOR,
        procesador: extracto.PROCESADOR
      }

      trackPromise(

        ExtractoService.descargarExtractoCabal(data)
          .then(response => {
            var fileURL = URL.createObjectURL(response.data);
            window.open(fileURL, "");
          })
          .catch(error => {
            Popup.queue(this.notifiPopup("Error", MENSAJE.ERROR_INESPERADO));
          })

      )
    }
  }

  dibujarExtracto() {
    return this.dibujarExtractoCabal();
  }

  dibujarExtractoCabal() {
    if (this.state.periodoElegido === PERIODO_A_LA_FECHA) {

      const { datosTarjeta } = this.state;

      const cab = this.state.cabecera;
      const det = this.state.detalle;

      const detalle = det !== null ? det.map((item, index) => (
        <tr key={index}>
          <td className="detalle">{item.numeroTarjeta}</td>
          <td className="detalle">{item.fechaTransaccion}</td>
          <td className="detalle">{item.comercio}</td>
          <td className="detalle">{item.tipoTransaccion}</td>
          <td className="detalle"> {formatoSeparadorMilesValueExtracto(item.importeGuaranies)}</td>
        </tr>
      )) : <td></td>;

      if (this.state.detalle !== null && this.state.detalle.length === 0) {
        return <div></div>;
      }

      return (
        <div className="row extracto-cabal" id="extracto-cabal">
          <div className="col-md-12">
            <div className="card">
              <div className="card-header">
                <button
                  className="btn btn-cu-primary float-right"
                  onClick={() => this.imprimirExtracto("extracto-cabal")}
                >
                  Imprimir
                </button>
                <span className="titulo" style={{ fontSize: "1.5rem" }}>
                  Extracto de Cabal
                </span>
              </div>
              <div className="card-body">
                {/*this.state.detalle !== null && this.state.detalle.length > 0 ? */(
                  <div className="row">
                    <div className="col-12">
                      <div className="row">
                        <div className="col-md-12">
                          <MensajeUsuario tipo="INFO"
                            titulo="Considerar."
                            mensaje="Los montos por sus compras en el exterior que figuren en esta consulta,
                            pueden variar en su extracto del mes por la cotización." />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-3 d-flex">
                          <img
                            src="dist/img/credit/cabal_logo.png"
                            style={{ width: 120 }}
                            className="my-auto"
                            alt="logo cabal"
                          />
                        </div>
                        <div className="col-md-6">
                          <img
                            src="dist/img/Logo_CU_Verde.PNG"
                            style={{ width: 200 }}
                            className="mx-auto"
                            alt="logo CU"
                          />
                        </div>
                        <div
                          className="col-md-3"
                          style={{ paddingTop: 20, textAlign: "end" }}
                        >
                          <span style={{ fontSize: "1rem", fontWeight: "500" }}>
                            TITULAR
                          </span>
                          <br />
                          {datosTarjeta.NOMBRE_USUARIO}
                        </div>
                      </div>
                      <div className="row border">
                        <div className="col-md-4">
                          <span className="cabecera">TARJETA</span>{" "}
                          <span className="detalle"> {datosTarjeta.NUMERO_TARJETA}</span> -{" "}
                          <span className="cabecera">TIPO</span>{" "}
                          <span className="detalle">
                            {datosTarjeta.TIPO_TARJETA}
                          </span>
                        </div>
                        <div className="col-md-4">
                          <span className="cabecera">ESTADO</span>{" "}
                          <span className="detalle"> {datosTarjeta.DESC_ESTADO}</span>
                        </div>
                      </div>

                      <br />

                      <div className="row">
                        <div className="col-md-12">
                          <div className="row  table-responsive">
                            <table className="table border">
                              <thead>
                                <tr>
                                  <th className="cabecera">Número de tarjeta</th>
                                  <th className="cabecera">Fecha Operación</th>
                                  <th className="cabecera">Comercio</th>
                                  <th className="cabecera">Tipo</th>
                                  <th className="cabecera">Monto</th>
                                </tr>
                              </thead>
                              {detalle !== null && detalle.length > 0 ? <tbody>{detalle}</tbody> : <tbody></tbody>}
                            </table>
                          </div>
                        </div>
                      </div>
                      <br />
                    </div>
                  </div>
                ) /*: (
                    <div></div>
                )*/}
              </div>
            </div>
          </div>
        </div>
      );

    }

  }


  imprimirExtracto(idDiv) {
    var contenido = document.getElementById(idDiv).innerHTML;
    var contenidoOriginal = document.body.innerHTML;
    document.body.innerHTML = contenido;
    window.print();
    document.body.innerHTML = contenidoOriginal;
  }


  render() {

    /*var list = this.state.listaPeriodo;
    if (this.state.listaPeriodo.length === 0)
      list = this.obtenerListaPeriodo();*/

    return (
      <div className="content-wrapper">
        <Titulo texto="Extracto de Tarjeta" />
        <section className="content">
          <div className="container">
            <div className="row">
              <div className="col-md-12" style={{ zIndex: 1 }} >
                <div className="card">
                  <div className="card-header">
                    <DatosSocio />
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        <label className="input-label-bold">Mes/Año *</label>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <Select
                            required="true"
                            placeholder="-- Seleccione --"
                            onChange={this.handleChangePeriodoSelector}
                            options={this.state.listaPeriodo}
                            isClearable
                            noOptionsMessage={() => "SIN DATOS"}
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <button
                          className="btn btn-cu-primary"
                          onClick={() => this.descargarExtracto()}
                        >
                          <FontAwesomeIcon icon={faCheck} /> Consultar
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {this.dibujarExtracto()}
          </div>
        </section>
      </div>
    );
  }
}
